const STORAGE_KEY = "ba-chat-notification-sound-muted";

export const NOTIFICATION_SOUND_PREFERENCE_EVENT =
	"notification-sound-preference-changed";

export const NOTIFICATION_SOUND_STORAGE_KEY = STORAGE_KEY;

export const isNotificationSoundMuted = (): boolean => {
	if (typeof localStorage === "undefined") return false;
	return localStorage.getItem(STORAGE_KEY) === "true";
};

export const setNotificationSoundMuted = (muted: boolean): void => {
	if (typeof localStorage === "undefined") return;
	localStorage.setItem(STORAGE_KEY, String(muted));
	window.dispatchEvent(
		new CustomEvent(NOTIFICATION_SOUND_PREFERENCE_EVENT, {
			detail: { muted },
		}),
	);
};
